// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrderPushedOut from './order-pushed-out';
import React from 'react';

function OrderPushedOutPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-pushed-out-page">
            <OrderPushedOut />
        </AuthenticatedPage>
    );

}
OrderPushedOutPage.displayNAme = 'OrderPushedOutPage';
export default OrderPushedOutPage;
